import { useNavigate } from "react-router";
import { api_getVideoSignedURL } from "../API/axios";
import { BubbleChart } from "./Charts/BubbleChart";
import { hl_config, zn_config } from "./Charts/configs/filter_configs";

const pitchMapping = {
  快速球: "ball_fb",
  曲球: "ball_cb",
  變速球: "ball_ch",
  伸卡球: "ball_ft",
  滑球: "ball_sl",
  指叉球: "ball_sp",
  卡特球: "ball_ct",
  慢速曲球: "ball_sc",
  叉指快速球: "ball_sff",
  蝴蝶球: "ball_kn",
  其他: "ball_ot",
  未知: "ball_un",
};

export const pitchNameMapping = {
  全部: "ALL",
  四縫: "FB",
  曲球: "CB",
  變速球: "CH",
  伸卡: "FT",
  滑球: "SL",
  指叉球: "SP",
  卡特: "CT",
  慢速曲球: "SC",
  快速指叉球: "SFF",
  蝴蝶球: "KN",
  其他: "OT",
  直球: "FB+FT",
};

export const pitchNameMapping2 = {
  全部: "ALL",
  四縫: "FB",
  曲球: "CB",
  變速球: "CH",
  伸卡球: "FT",
  滑球: "SL",
  指叉球: "SP",
  卡特: "CT",
  慢速曲球: "SC",
  快速指叉球: "SFF",
  蝴蝶球: "KN",
  其他: "OT",
  直球: "FB",
};

const tabStatus = (tab, status) => {
  if (tab === status) return "tab_block tab_selected";
  else return "tab_block";
};

const displayTab = (type, title, mode, setMode, arrow = false) => {
  return (
    <div
      className={tabStatus(type, mode)}
      onClick={() => {
        setMode(type);
      }}
    >
      <div className="tab">{title}</div>
      {arrow ? <div className="tab_arrow" /> : []}
    </div>
  );
};

const FilterTabFrame = ({ ballData, mode, setMode }) => {
  // const zoneRef = useRef(null)
  // const fieldRef = useRef(null)
  // const navigate = useNavigate()
  let n_zn_config = { ...zn_config },
    n_hl_config = { ...hl_config };
  const root_address =
    process.env.NODE_ENV === "production"
      ? "https://filter.stats-insight.com"
      : "http://localhost:3000";
  n_zn_config.options.onClick = (event, element) => {
    api_getVideoSignedURL({
      object: `GameVideo/${element[0].element.$context.raw.year}/J61qWKmDQnVG3VoARPPgm4hAWuaCai0/G${element[0].element.$context.raw.vname}/G${element[0].element.$context.raw.vname}.m3u8`,
    }).then((res) => {
      // navigate(`/video`, { state: { url: res, timecode: element[0].element.$context.raw.tcode }})
      // TODO: fix year
      localStorage.setItem(
        "newTabTimeCode",
        element[0].element.$context.raw.tcode,
      );
      localStorage.setItem("newTabVideoUrl", res);
      localStorage.setItem("newTabGameNo", element[0].element.$context.raw.g);
      window.open(
        `${root_address}/play-by-play-video/${element[0].element.$context.raw.year}/${element[0].element.$context.raw.g}/${element[0].element.$context.raw.plateid}`,
        "_blank",
      );
    });
  };
  n_hl_config.options.onClick = (event, element) => {
    api_getVideoSignedURL({
      object: `GameVideo/${element[0].element.$context.raw.year}/J61qWKmDQnVG3VoARPPgm4hAWuaCai0/G${element[0].element.$context.raw.vname}/G${element[0].element.$context.raw.vname}.m3u8`,
    }).then((res) => {
      // navigate(`/video`, { state: { url: res, timecode: element[0].element.$context.raw.tcode }})
      localStorage.setItem(
        "newTabTimeCode",
        element[0].element.$context.raw.tcode,
      );
      localStorage.setItem("newTabVideoUrl", res);
      localStorage.setItem("newTabGameNo", element[0].element.$context.raw.g);
      window.open(
        `${root_address}/play-by-play-video/${element[0].element.$context.raw.year}/${element[0].element.$context.raw.g}/${element[0].element.$context.raw.plateid}`,
        "_blank",
      );
    });
  };
  // n_zn_config.options.onHover = (event, element, chart) => {
  //   if (element[0]) {
  //     const target_idx = element[0].element.$context.raw.map_idx
  //     if (target_idx) {
  //       const chartref = fieldRef.current
  //       chartref.tooltip.setActiveElements([{datasetIndex: 0, index: target_idx}], {x: 0, y: 0})
  //       console.log(chartref.config.data, zoneRef.current.config.data)
  //       chartref.update()
  //     }
  //   }
  // }
  return (
    <>
      <div className="page_tab_frame2">
        {displayTab("pitch", "進壘 & 落點", mode, setMode, true)}
        {/*displayTab('hit', '擊出 & 落點', mode, setMode, true)*/}
      </div>
      <div className="tab_content">
        <div className="filter_result_chart">
          <BubbleChart data={ballData.zone} config={n_zn_config} />
        </div>
        <div className="filter_result_chart">
          <BubbleChart data={ballData.field} config={n_hl_config} />
        </div>
      </div>
    </>
  );
};

const FilterTable = ({ sheet, dSheet, mode, setMode }) => {
  const TableHeader = ({ headers }) => {
    return (
      <tr>
        {headers.map((e) => (
          <th>{e}</th>
        ))}
      </tr>
    );
  };
  const TableData = ({ title, data }) => {
    return (
      <tr>
        <td className="left_title">
          {title} <span>{pitchNameMapping[title]}</span>
        </td>
        {data.map((e) => (
          <td>{e}</td>
        ))}
      </tr>
    );
  };
  return (
    <div className="filter_table">
      <div className="page_tab_frame2">
        {displayTab("discipline", "紀律", mode, setMode, mode === "discipline")}
        {displayTab("score", "成績", mode, setMode, mode === "score")}
        {displayTab("hit", "擊出", mode, setMode, mode === "hit")}
      </div>

      <table className="filter_form">
        <TableHeader headers={sheet[mode].headers} />
        <tbody>
          {dSheet
            ? dSheet[mode].map((e) => {
                return <TableData title={e.title} data={e.data} />;
              })
            : []}
          {sheet[mode].data.map((e) => {
            if (pitchNameMapping[e.title] === undefined) return [];
            return <TableData title={e.title} data={e.data} />;
          })}
        </tbody>
      </table>
    </div>
  );
};

export { FilterTabFrame, FilterTable };
